import { useMutation, useQueryClient } from '@tanstack/react-query';
import {
  createCustomSurveyTemplate,
  type CreateCustomSurveyTemplateRequest,
  type CustomSurveyTemplate,
} from '../../api/customSurveyTemplates';
import { customSurveyTemplateKeys } from '../queries/queryKeys';

export const useCreateCustomSurveyTemplateMutation = (options?: {
  onSuccess?: (data: CustomSurveyTemplate) => void;
  onError?: (error: Error) => void;
}) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: CreateCustomSurveyTemplateRequest) =>
      createCustomSurveyTemplate(data),
    onSuccess: (data) => {
      // Invalidate all template queries to refetch
      queryClient.invalidateQueries({ queryKey: customSurveyTemplateKeys.all });
      options?.onSuccess?.(data);
    },
    onError: (error: Error) => {
      options?.onError?.(error);
    },
  });
};
